import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqList = ({ items, prefix, accent = "text-[#ffcc00]" }) => (
  <Accordion type="single" collapsible className="space-y-3" data-testid={`${prefix}-accordion`}>
    {items.map(([q, a], i) => (
      <AccordionItem key={q} value={`${prefix}-${i}`} className="rounded-lg border border-white/10 bg-white/[0.03] px-5">
        <AccordionTrigger data-testid={`${prefix}-item-${i}`} className={`text-left font-semibold hover:no-underline ${accent}`}>{q}</AccordionTrigger>
        <AccordionContent className="text-white/80 leading-relaxed">{a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
